import * as Api from "./Api";

export default {
    upload(payload) {
        return Api.client.post(`/storeCaseAttachment`, payload);
    },
};